export const paymentLink = {
  'Choose another payment method': 'Elegir otra forma de pago',
  Unavailable: 'No disponible',
  'This payment method does not meet the necessary criteria Please contact Vialaser for more information':
    'No fue posible concluir la contratación en esta forma de pago porque no cumple con los criterios necesarios. Ponete en contacto con Vialaser para más información.',
  'You have financial pendencies, so you cannot buy with this payment method':
    'Tenés pendencias financieras, por eso no podés realizar tu compra en este método de pago',
  'This payment method is not available for this order':
    'Esta forma de pago no está disponible para este pedido',
  'Back to cart': 'Volver al carrito',
  'How do you want to pay?': '¿Cómo querés pagar?',
  'Choose a payment method to continue':
    'Elegí una forma de pago para continuar',
  'No payment method is available for this order Please contact the clinic':
    'Ninguna forma de pago está disponible para este pedido. Ponete en contacto con la clínica',
  'Buy in cash': 'Comprar al contado',
  'Come on! This promotion is limited': '¡Vamos! Esta promoción es limitada',
  'The promotion is ending': 'La promoción está terminando',
  'You have selected the 1x option, this is considered a payment in cash':
    'Has seleccionado la opción de 1x, esto caracteriza una compra al contado',

  'Updating budget': 'Actualización del presupuesto',
  'Processing your payment': 'Procesando su pago...',
  'Close payment link': 'Cerrar enlace de pago',

  'Hello, complete the payment': 'Hola completa el pago',
  'Hello {{customer}}, complete the payment':
    'Hola {{customer}},  completa el pago',
  'Of your order by informing the payment data':
    'De su pedido informando los datos de pago',

  Show: 'Mostrar',
  Hide: 'Esconder',

  'Order items_one': 'Artículo de su compra',
  'Order items_other': 'Artículos de su compra',
  Product: 'Producto',
  Package: 'Paquete',
  Combo: 'Combo',
  '{{item}} with {{sessions}} sessions of_one':
    '{{item}} con {{sessions}} sesione de',
  '{{item}} with {{sessions}} sessions of_other':
    '{{item}} con {{sessions}} sesiones de',

  'Card payment data': 'Datos de pago con tarjeta',
  'Card data': 'Datos da tarjeta',
  'Automatic debit payment data': 'Datos de pago con débito automático',

  'Order resume': 'Currículum de compra',
  'Payment method': 'Método de pago',
  'Coupon {{coupon}}': 'Cupón {{coupon}}',
  'Original value': 'Valor original',
  'Total discount': 'Descuento total',
  Total: 'Total',
  'You will pay': 'Tu vas a pagar',
  '{{installments}}x of {{value}}': '{{installments}}x de {{value}}',

  Select: 'Seleccionar',

  'Credit card': 'Tarjeta de crédito',
  'Recurrent card': 'Tarjeta recurrente',

  'Finish order': 'Finalizar compra',
  'Generate link': 'Generar enlace',

  'This payment is 100% secure!': '¡Este pago es 100% seguro!',
  'Vialaser ensures a secure transaction of your payment':
    'Vialaser garantiza una transacción segura de su pago.',

  'Alert!': '¡Alerta!',
  'As you chose to pay more than 12 installments, confirmation of your purchase will depend on the approval of the bank that issued the card Vialaser does not provide guarantees for approval of installments in excess of 12 installments':
    'Como optó por pagar en más de 12 cuotas, la confirmación de su compra dependerá de la aprobación del banco emisor de la tarjeta. Vialaser no otorga garantías para la aprobación de cuotas superiores a 12 cuotas.',

  Close: 'Cerca',
  Loading: 'Cargando...',

  'Ops something went wrong': 'Huy! Algo salió mal',
  'Something went wrong while trying to get your order data Please, try again!':
    'Se produjo un error al intentar obtener los datos de su pedido. ¡Inténtelo de nuevo!',
  'The budget status changed Please, contact the clinic for more information':
    'El estado del presupuesto cambió. Por favor, póngase en contacto con la clínica para obtener más información.',
  'Expired link! Contact the unit to get another one':
    '¡Enlace caducado! Póngase en contacto con la unidad para obtener otro.',

  'All right!': '¡Bueno!',
  'The payment was processed and the contract was generated!':
    '¡Se procesó el pago y se generó el contrato!',

  'Try again': 'Intentar otra vez',
  Home: 'Inicio',

  Copy: 'Copiar',
  Open: 'Abrir',

  'Nupay link generated successfully!': '¡Enlace de Nupay generado con éxito!',

  'The purchase discount refers to the default payment method discount + {{discount}} of your coupon {{coupon}} applied':
    'El descuento en tu compra se refiere al descuento por forma de pago + {{discount}} de tu cupón {{coupon}} aplicado.',

  'We made a transaction on your card in the amount of {{value}} that will be deducted from your first full installment':
    'Hicimos una transacción en su tarjeta por {{value}} el monto que se deducirá de su primera cuota completa',

  'The time to make the payment is over! Please contact the unit':
    '¡Se acabó el tiempo de hacer el pago! Por favor, póngase en contacto con la clínica.',

  Important: 'Importante',
  'This promotion soon will end! Complete the payment before the timer above ends':
    '¡Esta promoción pronto terminará! Complete el pago antes de que finalice el temporizador anterior.',
  'Please, confirm your data below to continue with your purchase':
    'Por favor, confirme los datos para continuar con su compra.',
  '* When filling in data other than those registered, your registration will be updated':
    '*Al rellenar datos distintos a los registrados, se actualizará tu inscripción.',
  'Your data was updated successfully!':
    '¡Tus datos se actualizaron exitosamente!',
  'Got it': 'Entiendo',

  'Talk to an attendant': 'Hablar con una representante',
  'Please confirm your document to continue your purchase':
    'Confirme su CI para continuar con su compra.',
  "Please confirm your guardian's document to continue your purchase":
    'Confirme el CI de su responsable legal para continuar con su compra.',
  'Confirm Document': 'Confirmar CI',
  'The document entered does not match the registration number, please contact the unit or try again':
    'El CI ingresado no coincide con el registro, comuníquese con la unidad o intente nuevamente',
  'Type the document here': 'Ingrese el CI aquí',
  'I agree with the <1>Contract Accession terms</1>':
    'Acepto los <1>términos de Adhesión al Contrato</1>',
  'Not long to finish your purchase, but before please choose where do you want to receive your confirmation code':
    'Falta poco para realizar tu compra, antes escoge por donde deseas recibir el código de confirmación:',

  'You have added an item that makes it impossible to make a purchase Please contact the clinic to adjust your budget':
    'Has añadido un artículo que imposibilita realizar una compra. Por favor contacte con la clínica para ajustar su presupuesto.',
  'You have areas with outstanding financial obligations Therefore, you will be unable to make this purchase until you resolve your pending issues Even so, if you wish in other payment method, you may acquire other areas that do not have financial liabilities':
    'Tienes áreas con pendientes financieras. Por lo tanto, no podrá realizar esta compra hasta que resuelva sus pendientes. Aun así, si desea utilizar otra forma de pago, podrá adquirir otras áreas que no tengan pendientes financieras.',

  'SAVE {{amount}}': 'AHORRA {{amount}}',
  'Paying in {{installments}}x on credit!':
    '¡Pagando en {{installments}} cuotas a crédito!',
  Selected: 'Seleccionado',
  'Pay by {{method}}': 'Pagar con {{method}}',
  'payment method selected: {{method}}':
    'Método de pago seleccionado: {{method}}',
  'I agree that by changing the payment method from <1>recurring card</1> to <3>credit card</3>, my credit card limit will be consumed':
    'Acepto que al cambiar el método de pago de <1>tarjeta recurrente</1> a <3>tarjeta de crédito</3>, se consumirá el límite de mi tarjeta de crédito',
  'Paying with PIX!': '¡Pagando con PIX!',
  '{{percentage}}% OFF': '{{percentage}}% OFF',
  'Change your payment method and get an extra discount':
    'Cambia tu método de pago y obtén un descuento extra',
  credit: 'crédito',

  'Select recurring': 'Seleccionar recurrente',
  'Return to recurring method': 'Volver al método recurrente',
  'By returning to the recurring method, the total of your purchase is {{value}}, although your card limit is not used If you accept to pay in the recurring method click here':
    'Al volver al método recurrente, el importe total de tu compra será de {{value}}, pero no se agotará el límite de tu tarjeta. Si quieres pagar con el método recurrente, clic aquí.',
  'By returning to the recurring method, your card limit is not used Are you sure you want to proceed?':
    'Al volver al método recurrente no se utiliza el límite de tu tarjeta. ¿Estás seguro que deseas continuar?',
  Yes: 'Sí',
  No: 'No',
  'Do you really want to keep the 1x installment condition for this budget?':
    '¿Realmente desea mantener la condición de pago en parcela única para este presupuesto?',

  'You are paying': 'USTED ESTÁ PAGANDO',
  '{{value}} in {{installments}}x the recurring':
    '{{value}} en {{installments}}x en recurrente',
  recurring: 'recurrente',
  'Select credit card': 'Seleccionar tarjeta de crédito',
  'Return to credit card method': 'Volver al método de tarjeta de crédito',
  'When you switch back to paying by credit card, the total amount of your purchase will be {{value}}. If you wish to pay by credit card, click here':
    'Al volver al método de tarjeta de crédito, el importe total de tu compra será de {{value}}. Si quieres pagar con el método de tarjeta de crédito, clic aquí.',
  'Are you sure you want to pay with credit card?':
    '¿Estás seguro que deseas pagar con tarjeta de crédito?',
  '{{value}} in {{installments}}x the credit':
    '{{value}} en {{installments}}x en crédito',
};
